if (!customElements.get('localization-form')) {
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('.f-disclosure-list')
			};

			this.elements.panel.removeAttribute('hidden')
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

			this.handleDropdownPos()
		}

		handleDropdownPos() {
			const offsetButton = this.elements.button.getBoundingClientRect().right
			if ((window.innerWidth - offsetButton) < 220) {
				this.elements.button.nextElementSibling && this.elements.button.nextElementSibling.classList.add('f-disclosure-list__right')
			}
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.removeAttribute('open')
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			const newLocale = event.currentTarget.dataset.value;
			this.elements.input.value = newLocale;
			
			if (window.location.pathname.includes('/collections/')) {
				const url = new URL(window.location.href);
				const keysToRemove = [];
				url.searchParams.forEach((value, key) => {
					if (key.startsWith('filter.')) {
						keysToRemove.push(key);
					}
				});
				keysToRemove.forEach(key => url.searchParams.delete(key));
				
				// Store query parameters to restore after language switch
				const cleanQuery = url.searchParams.toString();
				sessionStorage.setItem('languageSwitchQuery', cleanQuery);
				sessionStorage.setItem('languageSwitchLocale', newLocale);
			}
			
			if (form) form.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.toggleAttribute('open')
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON' || event.relatedTarget && !event.relatedTarget.classList.contains('f-disclosure-list__option')
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel(shouldClose);
			}
		}
	}
	customElements.define('localization-form', LocalizationForm);
}

(function() {
	function handleLanguageRedirect() {
		// Check if we need to restore query parameters after language switch
		if (sessionStorage.getItem('languageSwitchQuery') && window.location.pathname.includes('/collections/')) {
			const storedQuery = sessionStorage.getItem('languageSwitchQuery');
			const currentUrl = new URL(window.location.href);
			const currentQuery = currentUrl.searchParams.toString();
			
			// If query parameters don't match, redirect immediately
			if (currentQuery !== storedQuery) {
				const finalUrl = currentUrl.pathname + (storedQuery ? '?' + storedQuery : '');
				sessionStorage.removeItem('languageSwitchQuery');
				sessionStorage.removeItem('languageSwitchLocale');
				// Use replace to avoid adding to history and redirect immediately
				window.location.replace(finalUrl);
				return;
			} else {
				// Query params match, just clean up
				sessionStorage.removeItem('languageSwitchQuery');
				sessionStorage.removeItem('languageSwitchLocale');
			}
		}
	}
	
	// Execute immediately, synchronously, before any rendering
	// This prevents the blank product grid from appearing
	handleLanguageRedirect();
})();
